import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import './Accordion.css';
import {
  HomeUpdatedonedev,
  HomeUpdatedtwodev,
  HomeUpdatedthreedev,
  HomeUpdatedfourdev,
  HomeUpdatedfivedev,
  HomeUpdatedsixdev,
  HomeUpdatedsevendev,
  HomeUpdatedeightdev,
  discoveryBackground,
  HomeUpdatedArrowIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

const AccordionItem = ({
  title,
  icon,
  contentMainTitle,
  contentMainContent,
  contentTitle,
  content,
  linkText,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="card">
      <div
        className={`card-header ${isOpen ? "active" : ""}`}
        onClick={onToggle}
      >
        {title}
        <div className="svg-arrow-icon d-block d-lg-none">
          {HomeUpdatedArrowIcon}
        </div>
      </div>
      <div className={`collapse ${isOpen ? "show width" : "width"}`}>
        <div className="card-body">
          <div className="discovery-bg">{discoveryBackground}</div>
          <div className="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              fill="none"
              viewBox="0 0 20 36"
            >
              <path
                stroke="#F47A1F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M1.893 2.377l15.62 15.62-15.62 15.62"
              ></path>
            </svg>
          </div>
          <div
            className="main-title"
            dangerouslySetInnerHTML={{ __html: contentMainTitle }}
          />
          <div className="main-title-content">
            <p dangerouslySetInnerHTML={{ __html: contentMainContent }} />
          </div>
          <div class="content-wrap">
            <div class="icon">{icon}</div>
            <h3
              className="title"
              dangerouslySetInnerHTML={{ __html: contentTitle }}
            />
            <p dangerouslySetInnerHTML={{ __html: content }} />
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              {linkText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

function DiscoveryAcc() {
  const [activeIndex, setActiveIndex] = useState(0);

  // const handleToggle = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  const handleToggle = (index) => {
    // Set activeIndex to the clicked index if it's different from the current active index
    setActiveIndex(activeIndex === index ? activeIndex : index);
  };

  return (
    <section className="tekrevol-home-discovery overflow-x-hidden b2b-portal-seamless">
      <div className="accordion width" id="accordionHorizontalExample">
        <AccordionItem
          title="Project Discovery"
          contentMainTitle="Streamlined <span>Automotive App Development</span> Process</span>"
          contentMainContent="As a leading automotive app development company, we utilize an agile process to create scalable, secure, and efficient solutions tailored for the automotive industry. Leverage our expertise to enhance your automotive business."
          icon={HomeUpdatedonedev}
          contentTitle="Project Discovery"
          content="Identify automotive requirements and set precise development goals."
          linkText="Talk to Our Experts"
          isOpen={activeIndex === 0}
          onToggle={() => handleToggle(0)}
        />
        <AccordionItem
          title="Tech Stack Selection"
          contentMainTitle="Streamlined <span>Automotive App Development</span> Process</span>"
          contentMainContent="As a leading automotive app development company, we utilize an agile process to create scalable, secure, and efficient solutions tailored for the automotive industry. Leverage our expertise to enhance your automotive business."
          icon={HomeUpdatedtwodev}
          contentTitle="Tech Stack Selection"
          content="Select the optimal technology for high performance and seamless integration."
          linkText="Talk to Our Experts"
          isOpen={activeIndex === 1}
          onToggle={() => handleToggle(1)}
        />
        <AccordionItem
          title="UI/UX Design"
          contentMainTitle="Streamlined <span>Automotive App Development</span> Process</span>"
          contentMainContent="As a leading automotive app development company, we utilize an agile process to create scalable, secure, and efficient solutions tailored for the automotive industry. Leverage our expertise to enhance your automotive business."
          icon={HomeUpdatedthreedev}
          contentTitle="UI/UX Design"
          content="Create user-friendly interfaces tailored for drivers, dealerships, and customers."
          linkText="Talk to Our Experts"
          isOpen={activeIndex === 2}
          onToggle={() => handleToggle(2)}
        />
        <AccordionItem
          title="App Development"
          contentMainTitle="Streamlined <span>Automotive App Development</span> Process</span>"
          contentMainContent="As a leading automotive app development company, we utilize an agile process to create scalable, secure, and efficient solutions tailored for the automotive industry. Leverage our expertise to enhance your automotive business."
          icon={HomeUpdatedfourdev}
          contentTitle="App Development"
          content="Build robust automotive systems with integrated front-end and back-end features."
          linkText="Talk to Our Experts"
          isOpen={activeIndex === 3}
          onToggle={() => handleToggle(3)}
        />
        <AccordionItem
          title="Quality Assurance"
          contentMainTitle="Streamlined <span>Automotive App Development</span> Process</span>"
          contentMainContent="As a leading automotive app development company, we utilize an agile process to create scalable, secure, and efficient solutions tailored for the automotive industry. Leverage our expertise to enhance your automotive business."
          icon={HomeUpdatedfivedev}
          contentTitle="Quality Assurance"
          content="Ensure top performance, security, and cross-device compatibility."
          linkText="Talk to Our Experts"
          isOpen={activeIndex === 4}
          onToggle={() => handleToggle(4)}
        />
        <AccordionItem
          title="Deployment & Support"
          contentMainTitle="Streamlined <span>Automotive App Development</span> Process</span>"
          contentMainContent="As a leading automotive app development company, we utilize an agile process to create scalable, secure, and efficient solutions tailored for the automotive industry. Leverage our expertise to enhance your automotive business."
          icon={HomeUpdatedsixdev}
          contentTitle="Deployment & Support"
          content="Launch and provide continuous updates and support."
          linkText="Talk to Our Experts"
          isOpen={activeIndex === 5}
          onToggle={() => handleToggle(5)}
        />
        {/* <AccordionItem
          title="Support & Expand"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedsevendev}
          contentTitle="Support & Expand"
          content="We provide support and maintenance services for updating and optimizing your application further in use. We also work to expand and enhance your application, adding new features and functionalities as the business expands."
          isOpen={activeIndex === 6}
          onToggle={() => handleToggle(6)}
        /> */}
        {/* <AccordionItem
          title="Continuous Support & Optimization"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedeightdev}
          contentTitle="Continuous Support & Optimization"
          content="Offer ongoing support and optimization services. Monitor performance, gather feedback, and implement enhancements to drive sustained growth and innovation"
          isOpen={activeIndex === 7}
          onToggle={() => handleToggle(7)}
        /> */}
      </div>
    </section>
  );
}

export default DiscoveryAcc;
